import request from '../utils/request';


export function getEmployeesList(params) {
    return request({
        url: '/employee/get_list',
        method: 'get',
        params
    });
}


export function activeAccount(data) {
    return request({
        url: '/employee/active_account',
        method: 'post',
        data
    });
}

export function batchActiveAccount(data) {
    return request({
        url: '/employee/active_account_batch',
        method: 'post',
        data
    });
}


export function editEmployeeRemark(data) {
    return request({
        url: '/employee/edit_remark',
        method: 'post',
        data
    });
}


export function syncActiveEmployee(data) {
    return request({
        url: '/employee/sync_active',
        method: 'get',
        params: data
    });
}